const AutomationRule = {
  TypeTitle: "AutomationRule.TypeTitle",
  WintCard: "AutomationRule.WintCard",
  MonthlyProcessedReceipts: "AutomationRule.MonthlyProcessedReceipts",
  MonthlyProcessedReceiptsDescription: "AutomationRule.MonthlyProcessedReceiptsDescription",
  RuleType_0: "AutomationRule.RuleType_0",
  RuleType_1: "AutomationRule.RuleType_1",
  CreateSuccess: "AutomationRule.CreateSuccess",
  AddRule: "AutomationRule.AddRule",
  EditRule: "AutomationRule.EditRule",
  AutomatedEvents: "AutomationRule.AutomatedEvents",
  CreateDate: "AutomationRule.CreateDate",
  Concerns: "AutomationRule.Concerns",
  Counterparty: "AutomationRule.Counterparty",
  MaxAmount: "AutomationRule.MaxAmount",
  CreateRule: "AutomationRule.CreateRule",
  DeleteConfirmationTitle: "AutomationRule.DeleteConfirmationTitle",
  DeleteConfirmationDescription: "AutomationRule.DeleteConfirmationDescription",
  ReceiptDraftTodoHeader: "AutomationRule.ReceiptDraftTodoHeader",
  ReceiptDraftTodoHeaderDescription: "AutomationRule.ReceiptDraftTodoHeaderDescription",
  ReceiptDraftCreateRuleButtonText: "AutomationRule.ReceiptDraftCreateRuleButtonText",
  TagsHelpText: "AutomationRule.TagsHelpText",
  MinMaxDescription: "AutomationRule.MinMaxDescription",
  }
export default AutomationRule;